import React from "react";
import { Modal, Box } from "@mui/material";
import { UserMenuTrigger } from "../user-menu-trigger/user-menu-trigger";
import { CustomTypography } from "../custom-typography/custom-typography";
import { StatisticsRowTwo } from "./statistics-row-two";
import { CancelIcon } from "../../assets/icon";
import { DomainFocusBlock } from "./domain-focus-block/domain-focus-block";
import { CompetencyCard } from "./competency-card/competency-card";
import { CertificatesCard } from "./certificates-card/certificates-card";
import { AchievementCard } from "./achievement-card/achievement-card";
import { StatisticTimeCard } from "./statistic-time-card/statistic-time-card";
import {
  modalBoxStyles,
  headerBoxStyles,
  headerRightBoxStyles,
  contentBoxStyles,
  rowStyles,
} from "./styles";

interface StatisticModalProps {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
}

export const StatisticModal: React.FC<StatisticModalProps> = ({
  open,
  onClose,
  children,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalBoxStyles}>
        <Box sx={headerBoxStyles}>
          <DomainFocusBlock />
          <CustomTypography fontSize={20} fontWeight={600} color="#FFFFFF">
            {/* Sales Model Training */}
          </CustomTypography>
          <Box sx={headerRightBoxStyles}>
            <UserMenuTrigger isStatistic={true} />
            <CancelIcon
              color="#FFFFFF"
              onClick={onClose}
              style={{ cursor: "pointer" }}
            />
          </Box>
        </Box>
        <Box sx={contentBoxStyles}>
          <Box sx={rowStyles}>
            <AchievementCard />
            <StatisticTimeCard />
          </Box>
          <Box sx={rowStyles}>
            <CompetencyCard />
            <CertificatesCard />
          </Box>
          <StatisticsRowTwo />
        </Box>
      </Box>
    </Modal>
  );
};

export default StatisticModal;
